import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Modal from '@ublique/components/Modal'
import TagContainer from './components/TagContainer'
import SearchColumns from './components/SearchColumns'
import { isEmpty, union } from 'lodash'
import './index.scss'

const LockColumsModal = ({
  open,
  close,
  data: {
    columns,
    lockedColumns: lockedCols,
    lockedColumnsByModel: lockedColsByModel = [],
    onSave
  }
}) => {
  const { t } = useTranslation(['Common', 'Document'])
  const [lockedColumns, setLockedColums] = useState([])
  const [items, setItems] = useState()
  const [itemsLockedByModel, setItemsLockedByModel] = useState([])

  const onSaveModal = () => {
    const lockedToShow = isEmpty(itemsLockedByModel)
      ? lockedColumns
      : union(itemsLockedByModel, lockedColumns)
    onSave({ lockedToSave: lockedColumns, lockedToShow })
    close()
  }

  const onChangeValue = ({ selectedItems }) => {
    setLockedColums(selectedItems)
  }

  const onRemoveTag = (ev) => {
    const toRemove = ev.currentTarget.getAttribute('column')

    if (!isEmpty(toRemove)) {
      const filerLock = lockedColumns.filter((col) => col.id !== toRemove)
      setLockedColums(filerLock)
    }
  }

  const customHeaderModal = useCallback(() => {
    return (
      <div className='modal-header bx--modal-header__heading'>
        <h4>{t('Document:LockColumnsModal.TITLE')}</h4>
      </div>
    )
  }, [t])

  useEffect(() => {
    const itemsMulti =
      columns
        .filter((cf) => cf.headerName !== '')
        .filter((cf) => !lockedColsByModel?.includes(cf.field))
        .map((cf) => ({
          id: cf.field,
          label: cf.headerName
        })) ?? []

    if (!isEmpty(lockedCols) && !isEmpty(itemsMulti)) {
      const prelocked = itemsMulti.filter((item) =>
        lockedCols.includes(item.id)
      )
      setLockedColums(prelocked)
    }

    setItems(itemsMulti)

    const itemsMultiLockedByModel =
      columns
        .filter((cf) => cf.headerName !== '')
        .filter((cf) => lockedColsByModel?.includes(cf.field))
        .map((cf) => ({
          id: cf.field,
          label: cf.headerName
        })) ?? []

    setItemsLockedByModel(itemsMultiLockedByModel)
  }, [columns])

  return (
    <Modal
      size='md'
      open={open}
      onRequestClose={close}
      onRequestSubmit={onSaveModal}
      secondaryButtonText={t('Common:Cancel')}
      primaryButtonText={t('Common:Save')}
      modalHeading={customHeaderModal()}
      className='lock-modal-inputview'
    >
      {!isEmpty(itemsLockedByModel) && (
        <div className='lockbymodel-tag-container'>
          <span>{t('Document:LockColumnsModal.LOCKED_BY_ADMIN')}</span>
          <span>{itemsLockedByModel?.map((col) => col.label).join(', ')}</span>
        </div>
      )}

      <div className='lock-tag-container'>
        <TagContainer
          t={t}
          tagList={lockedColumns}
          noFilterList={itemsLockedByModel}
          onRemoveTag={onRemoveTag}
        />
      </div>
      <div className='lock-search-container'>
        <SearchColumns
          t={t}
          items={items}
          onChangeValue={onChangeValue}
          selected={lockedColumns}
        />
      </div>
    </Modal>
  )
}

export default LockColumsModal
